import { useContext } from "react";
import { RestorationProjectsContext } from "../components/context/restoration-projects.context";
export const useRestorationProjects = () => (useContext(RestorationProjectsContext) || []);